module.exports = __webpack_public_path__ + "img/banner-TV-2__lg.2283cb7b.jpg";